/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as siteActions from 'actions/siteActions';
import Status from 'containers/Status';
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import { getUser, getTechId, isLoadingUser } from 'utils/userManager';
export class Header extends React.Component {

    constructor(props, context) {
        super(props, context);

        const { oidc } = props;
        const techId = getTechId(getUser(oidc));
        if (techId) {
            mouseFlowUtils.setTechId(techId);
        }
    }

    render() {

        const { user, siteActions, oidc } = this.props;

        let iconStyleLeft = {};

        const userId = user.get('userId');
        const userNotReady = !getUser(oidc);

        let headerTools = (
            <span className="valign-wrapper">
                <Status
                    userId={userId}
                    isSelf={true}
                    currentUserId={userId}
                /></span>
        );

        let nameDisplay = user.get('name');

        if (userNotReady) {
            iconStyleLeft = {
                display: 'none'
            };
            nameDisplay = '';
            headerTools = null;
        }

        return (<AppBar
            title={nameDisplay}
            titleStyle={{
                color: '#fff',
                fontSize: '1em'
            }}
            style={{
                position: "fixed",
                top: 0,
                left: 0
            }}
            iconStyleLeft={iconStyleLeft}
            children={headerTools}
            iconStyleRight={{
                marginTop: '0'
            }}
            onLeftIconButtonTouchTap={(e) => {
                e.preventDefault();
                siteActions.toggleDrawer('leftDrawer');
            }} />);
    }
}

Header.propTypes = {
    user: PropTypes.object,
    siteActions: PropTypes.object,
    oidc: PropTypes.object
    // ,
    // techData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.get('user'),
        oidc: state.get('oidc'),
        site: state.get('site')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        siteActions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.js